module.exports = __webpack_public_path__ + "static/media/recreationadult.75db0f08.jpg";